import { Box, Typography } from "@mui/material";
import { Close, Done } from "@mui/icons-material";
import { RiskMonitoring } from "../hooks/useAddSolutionForm";
import { formatDate } from "./incident-section/map/information-cards/formatting";

const columnStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "start",
  alignItems: "start",
};
const rowStyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "start",
  alignItems: "center",
};

export function ReadOnlyRiskMonitoring({
  riskMonitoring,
  shapeCreatedAt,
}: {
  riskMonitoring: RiskMonitoring;
  shapeCreatedAt: number;
}) {
  const isEnabled = riskMonitoring?.isEnabled;
  const buffer = riskMonitoring?.buffer || "";
  const created = formatDate(shapeCreatedAt);

  return (
    <Box sx={columnStyle}>
      {isEnabled ? (
        <>
          <Box sx={rowStyle}>
            <Done fontSize="large" color="success" />
            <Typography variant="body1">
              Buffer alert set: {buffer} km
            </Typography>
          </Box>
          <Box sx={rowStyle}>
            <Done fontSize="large" color="success" />
            <Typography variant="body1">
              Initial Outline Set: {created}
            </Typography>
          </Box>
        </>
      ) : (
        <>
          <Box sx={rowStyle}>
            <Close fontSize="large" color="error" />
            <Typography variant="body1">No buffer alert set</Typography>
          </Box>
        </>
      )}
    </Box>
  );
}
